module.exports = __webpack_public_path__ + "img/sForToad_350x350.cf928bdd.jpg";